<kendo-textbox #filterBox
               [placeholder]="placeholder"
               [value]="filterValue"
               (inputBlur)="onFilterInputBlur()"
               (inputFocus)="onFilterInputFocus()"
               (valueChange)="onFilterTextChange($event)">
  <ng-template kendoTextBoxPrefixTemplate
               *ngIf="showSearchButton">
    <button kendoButton
            (click)="onButtonClick()"
            [svgIcon]="searchSvg"></button>
  </ng-template>
</kendo-textbox>
